import React, { Component } from 'react'
import './index.less'
interface TextInfoProps {
  title: string
  brief: string
}
export default class TextInfo extends Component<TextInfoProps> {
  render() {
    return (
      <div className='text-info'>
        <span>{this.props.title}</span>
        <span>{this.props.brief}</span>
      </div>
    )
  }
}
